import React, {useEffect, useState} from 'react';
import {Server} from "./ServerPopup";

export const ServerPopupContainer = ({
																			 popups = [],
																			 currentRestaurantId,
																			 onDoneClick,
																			 onExternalLinkClick,
																			 onMenuEntryLinkClick,
																			 onRestaurantLinkClick,
																			 onOverlayClick
																		 }) => {

	const [popupIndex, setPopupIndex] = useState(0);
	useEffect(() => {
		setPopupIndex(0);
	}, [currentRestaurantId])
	const currentPopup = popups.length > 0 ? popups[popupIndex] : null
	if (!currentPopup) return null;

	return <Server
		key={currentPopup.id}
		title={currentPopup.title}
		description={currentPopup.text}
		image={currentPopup.image}
		onDoneClick={() => onDoneClick(currentPopup.id)}
		onExternalLinkClick={onExternalLinkClick}
		onMenuEntryLinkClick={(mainCategoryId, categoryId, menuEntryId) => {
			onMenuEntryLinkClick(mainCategoryId, categoryId, menuEntryId);
		}}
		onOverlayClick={() => {
			if (popupIndex < popups.length - 1) {
				setPopupIndex(popupIndex + 1)
			} else {
				onOverlayClick()
			}
		}}
		onRestaurantLinkClick={onRestaurantLinkClick}
	/>
}
